module.exports = __webpack_public_path__ + "img/imagem4.be547aa4.svg";